import styled from "styled-components";
import { Common } from "@lainco/react-toolbox";

export function Sidebar({ title, children, padding }) {
  return (
    <aside style={{ width: "32em", borderLeft: "1px solid #ccc", padding: padding ?? "2em 1em", boxSizing: "border-box" }}>
      <Common.Col gap="2em" rows={title ? "auto 1fr" : "1fr"}>
        {title && <Title>{title}</Title>}
        <div>{children}</div>
      </Common.Col>
    </aside>
  );
}

const Title = styled.div`
  font-size: 1.2em;
  font-weight: 600;
  color: #777;
`;
